import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../components/forms/ConfirmForm";
import {cancelCheckPaymentStatus} from "../../actions/AccountApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class CheckPaymentStatusFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit() {
    return this.props.checkPaymentStatus({salesOrderId: this.props.salesOrderId})
      .then((response) => {
        if (response.data.checkPaymentStatus.errors.length <= 0) {
          this.props.cancelCheckPaymentStatus();
        } else {
          let errors = createValidationErrors(response.data.checkPaymentStatus.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelCheckPaymentStatus();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        message="This will check if a stripe payment has been done. Would you like to proceed?"
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const CHECK_STATUS = gql`
  mutation checkPaymentStatus($salesOrderId: ID!) {
    checkPaymentStatus(salesOrderId: $salesOrderId) {
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(CHECK_STATUS, {
    props: ({ mutate }) => ({
      checkPaymentStatus: (data) => mutate({
        variables: data
      })
    })
  })  
);


export default connect(null, {cancelCheckPaymentStatus})(withQueries(CheckPaymentStatusFormContainer));